import operatorMapper from '../../mapper-filter/operatorMapper';
import operatorImpcMapper from '../../mapper-filter/operatorImpcMapper';
import filterIMPCCodesIfExistsInPostalOperators from '../../mapper-filter/filterImpc';
import {
  LEFT_MAIL_PROCESSING_CENTER_CHECKED,
  LEFT_POSTAL_OPERATOR_CHECKED,
  LEFT_POSTAL_OPERATOR_EXPANDED,
  RETRIEVE_ALL_LEFT_OPERATORS_SUCCESS,
  RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_SUCCESS,
  RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_SUCCESS, RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_SUCCESS,
  RETRIEVE_LEFT_OPERATORS_BY_ROLE_SUCCESS,
  RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_SUCCESS,
  RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_SUCCESS,
  SELECT_ALL_LEFT_MAIL_PROCESSING_CENTERS,
  SELECT_ALL_LEFT_POSTAL_OPERATORS,
  SET_SELECTED_OPERATOR_IMPC_ON_TABLE,
  SWAP_TREES,
  UNSELECT_ALL_LEFT_MAIL_PROCESSING_CENTERS,
  UNSELECT_ALL_LEFT_POSTAL_OPERATORS,
} from '../actions/types/OperatorImpcActionTypes';
import { RESET_ASSET_TYPE, SET_ASSET_TYPE } from '../../../../asset-types/redux/actions/types/AssetTypesActionTypes';

export const initialState = {
  nodes: [],
  checkedPostalOperators: [],
  checkedMailProcessingCenters: [],
  expandedPostalOperators: [],
  directionSwitched: false,
  selections: [],
  selectedOperator: '',
  selectedImpc: '',
};
const allChildNodeValues = (nodes) => nodes.map((node) => node.children.map((mPC) => mPC.value))
  .reduce((initial, impcCodes) => initial.concat(impcCodes));

export const leftPostalOperatorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_SUCCESS: case RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_SUCCESS
    : case RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_SUCCESS:
      return {
        ...state,
        nodes: operatorImpcMapper(action.payload),
        isLoading: false,
      };
    case RETRIEVE_LEFT_OPERATORS_BY_ROLE_SUCCESS: case RETRIEVE_ALL_LEFT_OPERATORS_SUCCESS:
      return {
        ...state,
        nodes: operatorMapper(action.payload),
        isLoading: false,
      };
    case RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_SUCCESS: case LEFT_MAIL_PROCESSING_CENTER_CHECKED:
      return {
        ...state,
        checkedMailProcessingCenters: filterIMPCCodesIfExistsInPostalOperators(
          action.payload,
          state.nodes,
        ),
      };
    case RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_SUCCESS:
      return {
        ...state,
        checkedPostalOperators: state.nodes.filter((operator) => action.payload.includes(operator.value)).map((item) => item.value),
      };
    case LEFT_POSTAL_OPERATOR_CHECKED:
      return {
        ...state,
        checkedPostalOperators: action.payload,
      };
    case LEFT_POSTAL_OPERATOR_EXPANDED:
      return {
        ...state,
        expandedPostalOperators: [...action.expandedPostalOperators],
      };
    case SELECT_ALL_LEFT_POSTAL_OPERATORS:
      return {
        ...state,
        checkedPostalOperators: allChildNodeValues(action.payload.nodes),
      };
    case SELECT_ALL_LEFT_MAIL_PROCESSING_CENTERS:
      return {
        ...state,
        checkedMailProcessingCenters: allChildNodeValues(action.payload.nodes),
      };
    case UNSELECT_ALL_LEFT_POSTAL_OPERATORS:
      return {
        ...state,
        checkedPostalOperators: [],
      };
    case UNSELECT_ALL_LEFT_MAIL_PROCESSING_CENTERS:
      return {
        ...state,
        checkedMailProcessingCenters: [],
      };
    case SET_SELECTED_OPERATOR_IMPC_ON_TABLE:
      return {
        ...state,
        selectedOperator: action.selectedOperator,
        selectedImpc: action.selectedImpc,
      };
    case SWAP_TREES:
      return {
        ...state,
        nodes: action.payload.newLeft.nodes,
        checkedMailProcessingCenters: action.payload.newLeft.checkedMailProcessingCenters,
        expandedPostalOperators: action.payload.newLeft.expandedPostalOperators,
      };
    case SET_ASSET_TYPE: case RESET_ASSET_TYPE:
      return {
        ...state,
        checkedMailProcessingCenters: [],
      };
    default:
      return state;
  }
};
